import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import reservation from "../../services/reservation.js"
import Footer from "../utils/Footer";
import Header from "../utils/Header";
import API_BASE_URL from "../../config.js";
import PhoneInput from "react-phone-input-2";
import WompiPayment from "../payments/WompiPayment.js";
import Swal from 'sweetalert2';
import Cancelar from "../../assets/Cancelar.png";
import iconLetoh from "../../assets/iconLetoh.png"
import "react-phone-input-2/lib/style.css";

const ListingConfirm = () => {
  const { listingId } = useParams();
  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [searchParams] = useSearchParams(); // Inicializa el hook
  const checkIn = searchParams.get("checkIn");
  const checkOut = searchParams.get("checkOut");
  const guests = searchParams.get("guests");
  const discount = searchParams.get("discount");
  const totalPrice = searchParams.get("totalPrice");

  const [firstName, setFirstName] = useState(searchParams.get("firstName"))
  const [lastName, setLastName] = useState(searchParams.get("lastName"))
  const [email, setEmail] = useState(searchParams.get("email"))
  const [countryCode, setCountryCode] = useState(searchParams.get("countryCode"));
  const [phoneNumber, setPhoneNumber] = useState(searchParams.get("phoneNumber"));
  const [idNumber, setIdnumber] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [sendInfo, setSendInfo] = useState(false);

  const [paymentData, setPaymentData] = useState(null);

  const handleChangeNumber = (value, data) => {
    const code = `+${data.dialCode}`;
    const number = value.replace(code.replace('+', ""), "").trim();
    setCountryCode(code);
    setPhoneNumber(number);
  };

  const handleValidation = () => {

    if (!firstName.trim()) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Nombre requerido',
        text: 'Por favor, ingresa tu nombre.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        },
      });
      return false;
    }

    if (!lastName.trim()) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Apellido requerido',
        text: 'Por favor, ingresa tu apellido.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        },
      });
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim() || !emailRegex.test(email)) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Correo electrónico inválido',
        text: 'Por favor, ingresa un correo electrónico válido.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        },
      });
      return false;
    }

    if (!phoneNumber) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Número de teléfono requerido',
        text: 'Por favor, ingresa tu número de teléfono.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        },
      });
      return false;
    }
    if (phoneNumber.length < 6) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Número de teléfono requerido',
        text: 'Por favor, ingresa un número de teléfono válido.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        },
      });
      return false;
    }
    if (!idNumber.trim()) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Número de identidad requerido',
        text: 'Por favor, ingresa tu número de identidad.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        },
      });
      return false;
    }
    return true;
  };

  const handleReservation = async () => {
    if (handleValidation()) {
      setSendInfo(true)
      try {
        const onlyCountryCode = countryCode.replace("+","");
        const reservationData = {
          "listing_id": listingId,
          "start_date": checkIn,
          "end_date": checkOut,
          guest_data: {
            "first_name": firstName,
            "last_name": lastName,
            email,
            "guests": guests,
            "phone": onlyCountryCode + phoneNumber,
            "dni": idNumber,
            "zip_code": countryCode
          },
        };
        const response = await reservation(reservationData);
        response.totalPrice = Math.ceil(response.totalPrice / 100) * 100
        setPaymentData(response);

      } catch (error) {
        console.error("Error en la reservación:", error);
      }
    }
  };

  useEffect(() => {
    fetch(`${API_BASE_URL}/listings/${listingId}/`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("No se pudo cargar el alojamiento.");
        }
        return response.json();
      })
      .then((data) => {
        setListing(data.result);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError(err.message);
        setLoading(false);
      });
  }, [listingId]);

  if (loading) return <div className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-50">
    <img src={iconLetoh} alt="Icono Letoh" className="w-20 h-20 mb-4 animate-pulse" />
  </div>
  if (error) return <p className="text-center text-red-500 mt-4">{error}</p>;
  if (!listing) return <p className="text-center text-gray-500 mt-4">No se encontraron detalles.</p>;

  return (
    <div >
      <Header />
      <div className="px-4 border rounded-lg shadow-md overflow-hidden">
        <Swiper modules={[Navigation]} navigation loop className="w-full h-[30rem]">
          {listing.listingImages?.length > 0 ? (
            listing.listingImages.map((image, imgIndex) => (
              <SwiperSlide key={imgIndex}>
                <img src={image.url} alt={`Imagen ${imgIndex + 1}`} className="w-full h-full object-contain" />
              </SwiperSlide>
            ))
          ) : (
            <SwiperSlide>
              <img src="https://via.placeholder.com/300" alt="Imagen no disponible" className="w-full h-full object-contain" />
            </SwiperSlide>
          )}
        </Swiper>
        <h2 className="text-2xl text-primaryP font-bold mt-4">{listing.name || "Nombre no disponible"}</h2>
        <p className="text-gray-500">{listing.city || "Ubicación no disponible"}</p>
        <p className="">{checkIn} hasta {checkOut}</p>
        {/* <p className="flex justify-between text-[red]">
          <span>Descuento 5% </span>
          <span>{listing.currencyCode} ${Math.ceil(discount).toLocaleString('es-CO')}</span>
        </p> */}
        <p className="flex justify-between font-bold mt-2">
          <span>Total</span>
          <span>{listing.currencyCode} ${Math.ceil(totalPrice).toLocaleString('es-CO')}</span>
        </p>

      </div>
      <div className="px-4">

        <div className="mt-6 py-4 text-gray-500">
          <h3 className="text-2xl text-primaryP font-bold">Datos de la reserva</h3>
          <div className="mx-auto w-full max-w-md p-4 bg-white shadow-lg rounded-lg">

            <p className="text-sm mb-0">
              {listing.currencyCode} {listing.price ? `$${listing.price.toLocaleString('es-CO')} / noche (Dinámico)` : "Precio no disponible"}
            </p>
            <hr className="my-2" />
            <p className="text-sm mb-0  text-gray-400">Check in - Check out</p>
            <p className="text-sm pb-0">{checkIn} - {checkOut}</p>
            <hr className="my-2" />

            <p className="text-sm  mb-0">Número de huéspedes</p>
            <p className="text-sm pb-0">{guests} huéspedes</p>
            <hr className="my-2" />

            <label className="text-xs mb-0 text-gray-400">Nombre:</label>
            <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)}
              className="appearance-none border-none bg-transparent text-sm text-gray-700 focus:outline-none w-full px-0"
              name="first-name"
              autoComplete="given-name"
            />
            <hr className="my-0" />
            <label className="text-xs mb-0 text-gray-400">Apellido:</label>
            <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)}
              className="appearance-none border-none bg-transparent text-sm text-gray-700 focus:outline-none w-full px-0"
              name="last-name"
              autoComplete="family-name"
            />
            <hr className="my-0" />
            <label className="text-xs mb-0 text-gray-400">Correo electrónico:</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="appearance-none border-none bg-transparent text-sm text-gray-700 focus:outline-none w-full px-0"
              name="email"
              autoComplete="email"
            />
            <hr className="my-0" />
            <div className="flex flex-col space-y-3 w-full">
              <label className="text-xs text-gray-400">Número de Teléfono:</label>
              <PhoneInput
                country={"co"} // Colombia por defecto
                onChange={handleChangeNumber}
                enableSearch={true} // Búsqueda de países
                inputStyle={{
                  width: "100%",
                  padding: "10px",
                  paddingLeft: "45px",
                  borderRadius: "8px",
                  border: "none",
                }}
                buttonStyle={{
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                }}
              />
            </div>
            <hr className="my-0" />
            <label className="text-xs mb-0 text-gray-400">Número de identidad:</label>
            <input type="id" value={idNumber} onChange={(e) => setIdnumber(e.target.value)}
              className="appearance-none border-none bg-transparent text-sm text-gray-700 focus:outline-none w-full px-0"
            />
            <hr className="my-0" />
            <div className="flex items-center mt-4">
              <p
                href="/TYC LETOH SAS.docx"
                download
                htmlFor="terms"
                className="ml-2 text-sm text-[red] hover:text-blue-800">
                Tienes 20 minutos para completar el pago de tu reserva.
Si no lo realizas en ese tiempo, tu reserva será cancelada.
              </p>
            </div>
            <div className="flex items-center mt-4">
              <input type="checkbox" id="terms" checked={termsAccepted} onChange={() => setTermsAccepted(!termsAccepted)} />
              <a
                href="/TYC LETOH SAS.docx"
                download
                htmlFor="terms"
                className="ml-2 text-sm text-gray-700 underline hover:text-blue-800">
                Acepto los términos y condiciones
              </a>
            </div>
            <button
              onClick={handleReservation}
              disabled={!termsAccepted || sendInfo}
              className={`mt-4 px-4 py-2 w-full h-[45px] font-bold rounded-md transition 
                ${termsAccepted && !sendInfo ? 'bg-[#1F4F51] text-white hover:bg-[#17403F]' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}
              `}
            >
              Reserva ahora
            </button>
          </div>
          {paymentData && (
            <WompiPayment
              publicKey={paymentData.publicKey}
              amount={paymentData?.totalPrice ? Math.ceil(paymentData.totalPrice).toString() : "0"}
              reference={paymentData.reference_wompi}
              signature={paymentData.signature}
              currency={paymentData.currency}
              expirationTime={paymentData.expirationTime}
              guestEmail={paymentData.guest_email}
              guestFullName={paymentData.guest_full_name}
              guestZipCode={paymentData.guest_zip_code}
              guestPhone={paymentData.guest_phone}
              guestDni={paymentData.guest_dni}
            />
          )}
        </div>
      </div>
      <hr className="mt-2" />
      <Footer />
    </div>
  );
};

export default ListingConfirm;
